// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "BoxofficeStatic" + "." + "1f6df98c" + ".chunk.js";
};